/*
 * @Author: stevensh
 * @Date: 2020-03-04 13:49:39
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-04-14 18:43:29
 */
import { InboxOutlined } from '@ant-design/icons';
import { Button, message, Spin, Upload } from 'antd';
import React, { Component } from 'react';
import { getStorage } from 'utils/storage';
import { api_host, request } from 'utils/request';
import './index.less';

const isEn = getStorage('locale') === 'zh' ? false : true;

/**
 *  ImageSize 配置
 *  如果宽高是固定值，min max配置相同值
 */
export enum ImageSize {
  MinWidth = 0,
  MaxWidth = 50000,
  MinHeight = 0,
  MaxHeight = 32000
}

export function checkImgWH(file: any): PromiseLike<void> {
  const _URL = window.URL || window.webkitURL;
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = _URL.createObjectURL(file);
    img.src = objectUrl;
    img.onload = () => {
      if (
        img.width >= (ImageSize['MinWidth'] || 0) &&
        (ImageSize['MaxWidth'] ? img.width <= ImageSize['MaxWidth'] : true) &&
        img.height >= (ImageSize['MinHeight'] || 0) &&
        (ImageSize['MaxHeight'] ? img.height <= ImageSize['MaxHeight'] : true)
      ) {
        resolve();
      } else {
        message.error('图片上传尺寸不对，请重试');
        reject();
      }
      _URL.revokeObjectURL(objectUrl);
    };
  });
}

const fileToBuffer = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.addEventListener('loadend', () => {
      resolve(reader.result);
    });
  });
};

const replaceLastDot = (str, target) => {
  const reg = new RegExp(`${target}(?=([^${target}]*)$)`);
  return str.replace(reg, '.');
};

const { Dragger } = Upload;
interface IProps {
  className?: string;
  accept?: Array<string> | string;
  maxSize?: number; //单位kb
  text?: string;
  onChange?: any;
}

interface IState {
  loading: boolean;
  uploadApi: string;
}

export default class ImgUpload extends Component<IProps, IState> {
  api = api_host + '/Ppbot/System/getSignedUrl';

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      uploadApi: ''
    };
  }

  getUploadApi = async (url: string, file: any) => {
    return fetch(
      `${url}?name=${replaceLastDot(file.name.replace(/\./g, '-'), '-')}`,
      {
        method: 'get'
      }
    )
      .then(response => {
        return response.json();
      })
      .then(data => {
        return data.result;
      });
  };
  uploadAjax = (data, url) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.upload.onprogress = e => {
        if (e.lengthComputable) {
          this.setState({
            ...this.state,
            loading: true
          });
        }
      };
      xhr.onreadystatechange = e => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status >= 200 && xhr.status < 300) {
          this.setState({
            ...this.state,
            loading: false
          });
          resolve(e.target);
        } else {
          this.setState({
            ...this.state,
            loading: false
          });
          const error = {
            message: '上传失败！'
          };
          message.error('图片上传失败');
          reject(error);
        }
      };
      xhr.open('PUT', url, true);
      xhr.send(data);
    });
  };
  beforeUpload = (file: any): boolean | PromiseLike<void> => {
    const { accept, maxSize, onChange } = this.props;

    const fileName = file.name;
    const imgExt = fileName.split('.').pop();

    const isSizeOk = maxSize ? file.size / 1024 < maxSize : true;
    const isAcceptOk = accept
      ? (function() {
          if (Array.isArray(accept)) {
            if (accept.indexOf(imgExt) < 0) {
              return false;
            }
          } else {
            if (imgExt !== accept) {
              return false;
            }
          }
          return true;
        })()
      : true;

    //文件大小比较
    if (!isSizeOk) {
      message.error(' 文件过大');
      return false;
    }

    if (!isAcceptOk) {
      message.error('文件格式有误');
      return false;
    }

    return new Promise(async (resolve, reject) => {
      const buffer = await fileToBuffer(file);

      const resp = await this.getUploadApi(this.api, file);

      let res = await this.uploadAjax(file, resp);
      //@ts-ignore
      if (res && res.status === 200) {
        // resolve({
        //   //@ts-ignore
        //   url: res.responseURL.split('?')[0],
        // });
        message.success(isEn ? 'success' : '图片上传成功');
        //@ts-ignore
        onChange(res.responseURL.split('?')[0]);
      }
    });
  };

  handleChange = info => {
    const { onChange } = this.props;
    if (info.file.status === 'uploading') {
      this.setState({
        ...this.state,
        loading: true
      });
      // console.log('info.file.status', info.file);
      return;
    } else if (info.file.status === 'done') {
      this.setState({
        ...this.state,
        loading: false
      });
      if (info.file.response) {
        message.success(isEn ? 'Success' : '图片上传成功');
        if (JSON.stringify(info.file.response.error) === '[]') {
          onChange(info.file.response.result.url);
        } else {
          message.error(isEn ? 'Failure' : '图片上传失败');
        }
      }
    }
  };

  render() {
    const { className, text } = this.props;
    const { loading, uploadApi } = this.state;
    return (
      <div className={`app-img-uploader ${className ? className : ''}`}>
        <Spin spinning={loading} tip="Uploading...">
          <Dragger
            onChange={this.handleChange}
            beforeUpload={this.beforeUpload}
            action={uploadApi}
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p>
              <Button> {isEn ? 'Upload' : '上传图片'}</Button>
            </p>
            <p className="mt-12">
              {isEn
                ? 'Click or drag file to this area to upload'
                : '单击或将上传的图片拖拽到此区域以上传'}
            </p>
          </Dragger>

          {text ? <p className="desc mt-12">{text}</p> : ''}
        </Spin>
      </div>
    );
  }
}
